module.exports = __webpack_public_path__ + "img/no-thumbnail.5dc0f8fe.jpg";